<div class="container">
  <img src="../../../../../assets/icons/tick-circle.svg" class="logo" />
  <div class="header">
    <p class="title-text">{{ title }}</p>
    <p class="subtitle-text">{{ subtitle }}</p>
  </div>

  <div class="footer">
    <div class="button-actions">
      <lib-ui-button *ngIf="role === 'investor'"
        [fullWidth]="true"
        size="l"
        (click)="dialogRefModal.close('closed'); goToDeposit()"
        [label]="'Hacer mi primer depósito'"
      ></lib-ui-button>
      <lib-ui-button
        variant="outline"
        [fullWidth]="true"
        size="l"
        (click)="dialogRefModal.close('closed')"
        [label]="'Explorar el portal'"
      ></lib-ui-button>
    </div>
  </div>
</div>
